import { Component, ViewChild, TemplateRef } from "@angular/core";
import { UserService } from "../../../services/user.service";
import { Arquitecto } from "../../../models/arquitecto.model";
import { MatDialog } from "@angular/material";
import { FormService } from "src/app/services/form.service";
import {
    FormBuilder,
    Validators,
    FormControl,
    FormGroup,
} from "@angular/forms";
import { RutValidator } from "ng2-rut";
import { NgxSpinnerService } from "ngx-spinner";
import { startWith, map } from "rxjs/operators";

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-arquitecto",
    templateUrl: "./arquitecto.component.html",
    styleUrls: ["./arquitecto.component.css"],
    providers: [UserService, FormService],
})
export class ArquitectoComponent {
     @ViewChild('confirmarReemplazo') confirmarReemplazoTemplate: TemplateRef<any>;
    @ViewChild("openModal") openModal: TemplateRef<any>;
    public rut_arq;
    public mail_arq;
    public invalidRut: Boolean;
    public arquitecto
    public rows = [];
    public form;
    public actualRow;
    public formRow;
    public formulario;

    public filteredOptions;
    public nombreComuna = new FormControl("", [Validators.required]);
    options = []; // = [];
    public selectedArq: number = null;

    public matcher = new FormService();

    public form251 = false;
    public form252 = false;
    public form253 = false;
    public form254 = false;
    public form255 = false;

    public form131 = false;
    public form132 = false;
    public form133 = false;

    constructor(
        private fb: FormBuilder,
        private _userService: UserService,
        private rutValidator: RutValidator,
        private dialog: MatDialog,
        private spinner: NgxSpinnerService
    ) {
        this.formulario = localStorage.getItem("form")


        if (this.formulario == "2-5.1") {
            this.form251 = true;
        }
        if (this.formulario == "2-5.2") {
            this.form252 = true;
        }
        if (this.formulario == "2-5.3") {
            this.form253 = true;
        }
        if (this.formulario == "2-5.4") {
            this.form254 = true;
        }
        if (this.formulario == "2-5.5") {
            this.form255 = true;
        }

        if (this.formulario == "1-3.1") {
            this.form131 = true;
        }
        if (this.formulario == "1-3.2") {
            this.form132 = true;
        }
        if (this.formulario == "1-3.3") {
            this.form133 = true;
        }

        this.rut_arq = this.fb.group({
            rut: ["", [Validators.required, this.rutValidator]],
        });


        this.mail_arq = this.fb.group({
            mail: [
                "",
                [
                    Validators.pattern(this.regexp),
                    Validators.required,
                    Validators.maxLength(50),
                ],
            ],
        });
        this.form = new FormGroup({
            mantieneProfesionales: new FormControl(""),
            adjuntaComunicacion: new FormControl(""),
        });

        if (!JSON.parse(localStorage.getItem("arquitectos"))) {
            localStorage.setItem("arquitectos", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("arquitectos"));
        }
        this.invalidRut = true;
        this.arquitecto = {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            profesion: "",
            recordId: "",
            mantieneProfesionales: "",
            adjuntaComunicacion: "",
        };
    }

    regexp = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    ngOnInit() { }

    ngAfterContentInit() {
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges.pipe(
            startWith(""),
            map((value) => this._filter(value))
        );
    }

    private _filter(value: string): string[] {
        const filterValue = ("" + value).toLowerCase();
        return this.options.filter((option) =>
            ("" + option).toLowerCase().includes(filterValue)
        );
    }

    get_arquitecto(rut) {
        this.spinner.show();

        this.cleanData();

        this._userService.getArquitecto(rut).subscribe(
            (response) => {
                /*  console.log("arquitecto", response); */

                if (response.message) {
                    this.arquitecto.rut = rut ? rut : "";
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.arquitecto.rut = response.rut ? response.rut : "";
                    this.arquitecto.nombre = response.nombre ? response.nombre : "";
                    this.arquitecto.apellido_mat = response.apellido_mat
                        ? response.apellido_mat
                        : "";
                    this.arquitecto.apellido_pat = response.apellido_pat
                        ? response.apellido_pat
                        : "";
                    this.arquitecto.direccion = response.direccion
                        ? response.direccion
                        : "";
                    this.arquitecto.direccion_complemento = response.direccion_complemento
                        ? response.direccion_complemento
                        : "";
                    this.arquitecto.direccion_num = response.direccion_num
                        ? response.direccion_num
                        : "";
                    this.arquitecto.comuna = response.comuna ? response.comuna : "";
                    this.arquitecto.fono = response.fono ? response.fono : "";
                    this.arquitecto.fax = response.fax ? response.fax : "";
                    this.arquitecto.mail = response.mail ? response.mail : "";

                    this.arquitecto.patente = response.patente ? response.patente : "";
                    this.arquitecto.profesion = response.profesion
                        ? response.profesion
                        : "";

                    this.arquitecto.recordId = response.recordId ? response.recordId : "";
                    this.arquitecto.mantieneProfesionales = this.form.value.mantieneProfesionales ? "mantieneProfesionales" : "noMantieneProfesionales",
                        this.arquitecto.adjuntaComunicacion = this.form.value.adjuntaComunicacion ? "adjuntaComunicacion" : "noAdjuntaComunicacion"
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                }
            },
            (error) => {
                console.log(error);
                this.spinner.hide();
            }
        );
    }

    cleanData() {
        this.arquitecto = {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            profesion: "",
            recordId: "",
        };
        this.rut_arq.reset();
    }

    update_arquitecto(rut, id) {
        this.get_arquitecto(rut);
        this.selectedArq = id;
    }

    saveArquitecto() {
        this.spinner.show();
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {
            if (this.arquitecto.rut == this.rows[x].rut) {
                this.delete_arquitecto(x);
            }
        }

        //elimina fila cuando la editan
        if (this.selectedArq != null) {
            this.delete_arquitecto(this.selectedArq);
            this.selectedArq = null;
        }

        this._userService.saveArquitecto(this.arquitecto).subscribe(
            (response) => {
                this.spinner.hide();
                if (response.update || response.save) {
                    $("#arq_modal").modal("hide");
                    const stored = localStorage.getItem("arquitectos");
                    this.rows = stored ? JSON.parse(stored) : [];

                    if (this.rows.length > 0) {
                        this.dialog.closeAll()
                        const dialogRef = this.dialog.open(this.confirmarReemplazoTemplate, {
                            width: '400px',
                            disableClose: true,
                            data: {}
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result === true) {
                                console.log("se quiere reemplazar");
                                this.newPropietario()
                            }
                        });
                    } else {
                        this.newPropietario()
                    }
                }
            },
            (error) => {
                this.spinner.hide();
                console.log(error);
            }
        );
    }

    newPropietario() {
        // Sobrescribir directamente con un solo objeto
        this.rows = [{
            rut: this.arquitecto.rut,
            nombre: this.arquitecto.nombre,
            apellido_mat: this.arquitecto.apellido_mat,
            apellido_pat: this.arquitecto.apellido_pat,
            direccion: this.arquitecto.direccion,
            direccion_num: this.arquitecto.direccion_num,
            direccion_complemento: this.arquitecto.direccion_complemento,
            comuna: this.arquitecto.comuna,
            fono: this.arquitecto.fono,
            fax: this.arquitecto.fax,
            mail: this.arquitecto.mail,
            mantieneProfesionales: this.form.value.mantieneProfesionales ? "mantieneProfesionales" : "noMantieneProfesionales",
            adjuntaComunicacion: this.form.value.adjuntaComunicacion ? "adjuntaComunicacion" : "noAdjuntaComunicacion",
            patente: this.arquitecto.patente,
            profesion: this.arquitecto.profesion,
        }];

        localStorage.setItem("arquitectos", JSON.stringify(this.rows));

        // Resetear campos y cerrar el diálogo
        this.arquitecto = {
            rut: "",
            nombre: "",
            mail: "",
            apellido_mat: "",
            apellido_pat: "",
            direccion: "",
            direccion_complemento: "",
            direccion_num: "",
            comuna: "",
            fono: "",
            fax: "",
            patente: "",
            profesion: "",
            recordId: "",
        };
        this.rut_arq.reset();
        this.dialog.closeAll();
    }

    delete_arquitecto(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("arquitectos", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem("arquitectos"));
            }
        }
    }

    getComunas() {
        if (JSON.parse(localStorage.getItem("comunas"))) {
            if (JSON.parse(localStorage.getItem("comunas")).length > 0) {
                this.options = JSON.parse(localStorage.getItem("comunas"));
            } else {
                this.options = [];
            }
        }

        this.filteredOptions = this.nombreComuna.valueChanges.pipe(
            startWith(""),
            map((value) => this._filter(value))
        );
    }

    add_antecedentesEmpresa() {
        this.formRow = {
            mantieneProfesionales: this.form.value.mantieneProfesionales
                ? "mantieneProfesionales"
                : "noMantieneProfesionales",
            adjuntaComunicacion: this.form.value.adjuntaComunicacion
                ? "adjuntaComunicacion"
                : "noAdjuntaComunicacion",
        };

        if (this.rows.length != 0) {
            this.rows[0].mantieneProfesionales = this.form.value.mantieneProfesionales
                ? "mantieneProfesionales"
                : "noMantieneProfesionales";
            this.rows[0].adjuntaComunicacion = this.form.value.adjuntaComunicacion
                ? "adjuntaComunicacion"
                : "noAdjuntaComunicacion";

            try {
                localStorage.setItem("arquitectos", JSON.stringify(this.rows));
                console.log("Datos guardados en localStorage exitosamente");
            } catch (error) {
                console.error("Error al guardar los datos en localStorage:", error);
            }
        }
    }
}
